/**
 * 日文
 */
export default {
  message: {
    hello: 'こんにちは、世界'
  }
}



// WEBPACK FOOTER //
// ./src/assets/script/i18n/jp.js